import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
  Tooltip,
  useTheme,
} from "@mui/material";
import {
  Logout,
  AccountCircle,
  Brightness4,
  Brightness7,
} from "@mui/icons-material";
import { useNavigate, Link } from "react-router-dom";
import { useColorMode } from "../../../theme/ThemeContext";
import logo from "./kaaslogo.png";
import logoWhite from "../Styles/KaasWhite.png";

const AdminNav = () => {
  const navigate = useNavigate();
  const { mode, toggleColorMode } = useColorMode();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/db-shiksha/kaas/login");
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        bgcolor: "background.paper",
        color: "text.primary",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Box
          component={Link}
          to="/db-shiksha/kaas/admin/dashboard"
          sx={{ display: "flex", alignItems: "center", textDecoration: "none" }}
        >
          <img 
            src={mode === 'dark' ? logoWhite : logo} 
            alt="KaaS Admin" 
            style={{ 
              height: "35px", 
              width: "auto", 
              objectFit: "contain"
            }} 
          />
          <Typography
            variant="h6"
            sx={{
              ml: 1.5,
              fontWeight: 800,
              color: "primary.main",
              display: { xs: "none", sm: "block" },
              letterSpacing: "-0.5px",
            }}
          >
            ADMIN PANEL
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Tooltip title="Toggle light/dark theme">
            <IconButton onClick={toggleColorMode} color="inherit">
              {mode === "dark" ? <Brightness7 sx={{ color: '#D4AF37' }} /> : <Brightness4 />}
            </IconButton>
          </Tooltip>

          <Tooltip title="Account settings">
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <Avatar
                sx={{
                  width: 35,
                  height: 35,
                  border: "2px solid #D4AF37",
                  bgcolor: "primary.main",
                }}
              >
                AD
              </Avatar>
            </IconButton>
          </Tooltip>
        </Box>

        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                zIndex: 0,
              },
            },
          }}
        >
          <MenuItem onClick={() => navigate("/db-shiksha/kaas/admin/profile")}>
            <ListItemIcon>
              <AccountCircle fontSize="small" />
            </ListItemIcon>
            Profile
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleLogout} sx={{ color: "error.main" }}>
            <ListItemIcon>
              <Logout fontSize="small" color="error" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default AdminNav;
